import React from "react";

export const Loading = () => {
    return (
        <div className="px-2 pt-2" style={{ position: 'absolute', top: 0 }}>Loading...</div>
    );
};

export default Loading;

